import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certissueActions } from '../../../../store/actions'
import moment from 'moment'
import PopSett from './PopSett'
import history from '../../../../route/history'
import { commons } from '../../../../hook/common'

const CertIssueDetail = (props) => {
  const queryString = require('query-string')
  const [state, setState] = useState({})
  const [historyInfo, setHistoryInfo] = useState({})
  const [certissueInfo, setCerissueInfo] = useState({})
  const [showSett, setShowSett] = useState(false)
  const [gnrlInfoCn, setGnrlInfoCn] = useState({})
  /**
   * 문서정보 조회
   */
  useEffect(() => {
    const locationInfo = props.location.state

    setHistoryInfo({
      ...historyInfo,
      tabStatus: locationInfo?.tabStatus,
      srhIssueType: locationInfo?.srhIssueType,
      srhPrchsNm: locationInfo?.srhPrchsNm,
      searchWord: locationInfo?.searchWord,
      srhFrom: locationInfo?.srhFrom,
      srhTo: locationInfo?.srhTo,
      srhOrder: locationInfo?.srhOrder,
      srhBy: locationInfo?.srhBy,
      pageIdx: locationInfo?.pageIdx || 1,
    })
    if (props.match.params.seq) {
      let crtSeq = props.match.params.seq
      props.getCertissueInfo(crtSeq)
    }

    //console.log(props);
  }, [])

  useEffect(() => {
    if (props.certissueInfo) {
      setCerissueInfo(props.certissueInfo)
      console.log('certissueInfo', props.certissueInfo)
      setGnrlInfoCn(props.certissueInfo?.gnrlInfoCn !== null ? null : JSON.parse(props.certissueInfo?.gnrlInfoCn))
    } else {
    }
  }, [props.certissueInfo])

  /**
   * 증명서 신청현황 이동
   */
  const goList = () => {
    let paramStr = queryString.stringify(historyInfo)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    // console.log('path', '/service/certissue' + paramStr)

    history.push('/service/certissue' + paramStr)
  }

  /**
   * 증명서 결제 취소
   */
  const doSett = (crtSeq) => {
    if (props.certissueInfo?.stlmAmt === null && props.certissueInfo?.stlmAmt <= 0) {
      props.error({ message: '결제 금액이 없습니다.' })
      return
    } else {
      setShowSett(true)
    }
  }

  return (
    <React.Fragment>
      {showSett && (
        <PopSett
          viewNm="결제취소"
          crtNm={props.certissueInfo?.crtNm}
          crtSeq={props.certissueInfo?.crtSeq}
          stlmAmt={props.certissueInfo?.stlmAmt}
          dlngId={props.certissueInfo?.dlngId}
          stlmOrdrNo={props.certissueInfo?.stlmOrdrNo}
          onClose={() => setShowSett(false)}
        />
      )}
      {/* contents */}
      <div id="contents">
        <div className="content-header">
          <h2>신청현황</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>증명서 신청</span>
            <span>신청현황</span>
            <em>상세페이지</em>
          </div>
        </div>

        <div className="detail-info">
          <div className="row">
            <p className="txt">
              <span>발급기관</span>
              {props.certissueInfo?.prchsNm}
            </p>
            <p className="tit">{props.certissueInfo?.crtNm}</p>
          </div>
          <ul className="steps mt25">
            <li className={props.certissueInfo?.sts === '01' ? 'on' : ''}>
              <span className="num">1</span>접수
            </li>
            <li className={props.certissueInfo?.sts === '02' ? 'on' : ''}>
              <span className="num">2</span>처리중
            </li>
            <li className={props.certissueInfo?.sts === '03' ? 'on' : ''}>
              <span className="num">3</span>발급완료
            </li>
          </ul>
        </div>
        <h3 className="h3-tit mt30">신청정보</h3>
        <table className="tbl-view">
          <caption>발급기관, 신청방법, 문서명, 발급번호, 신청일자, 진행상태, 발급일자 항목으로 구성</caption>
          <colgroup>
            <col className="col1" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">발급기관</th>
              <td>{props.certissueInfo?.prchsNm}</td>
            </tr>
            <tr>
              <th scope="row">신청방법</th>
              <td>{props.certissueInfo?.issueTypeNm}</td>
            </tr>
            <tr>
              <th scope="row">문서명</th>
              <td>{props.certissueInfo?.crtNm}</td>
            </tr>
            <tr>
              <th scope="row">발급번호</th>
              <td>{props.certissueInfo?.docid}</td>
            </tr>
            <tr>
              <th scope="row">신청일자</th>
              <td>
                {props.certissueInfo?.writedt === null
                  ? '-'
                  : moment(props.certissueInfo?.writedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
              </td>
            </tr>
            <tr>
              <th scope="row">진행상태</th>
              <td>
                {props.certissueInfo?.sts === '04' && <span className="text-red">{props.certissueInfo?.stsNm}</span>}
                {props.certissueInfo?.sts === '03' && <span className="text-black">{props.certissueInfo?.stsNm}</span>}
                {props.certissueInfo?.sts === '02' && <span className="text-blue">{props.certissueInfo?.stsNm}</span>}
              </td>
            </tr>
            {props.certissueInfo?.sts === '04' && gnrlInfoCn !== null && (
              <tr>
                <th scope="row">오류내용</th>
                <td>{gnrlInfoCn?.infoTxt}</td>
              </tr>
            )}
            <tr>
              <th scope="row">발급일자</th>
              <td>
                {props.certissueInfo?.issuedt === null
                  ? '-'
                  : moment(props.certissueInfo?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
              </td>
            </tr>
          </tbody>
        </table>
        {/* 운영 결제 관련 사용안함 2022-07-29
        <h3 className="h3-tit">결제정보</h3>
        <table className="tbl-view">
          <caption>결제수단, 결제일자, 결제금액, 취소일자 항목으로 구성</caption>
          <colgroup>
            <col className="col1" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">결제수단</th>
              <td>{props.certissueInfo?.stlmSeNm}</td>
            </tr>
            <tr>
              <th scope="row">결제일자</th>
              <td>
                {props.certissueInfo?.stlmDt === null
                  ? '-'
                  : moment('20' + props.certissueInfo?.stlmDt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
              </td>
            </tr>
            <tr>
              <th scope="row">결제금액</th>
              <td>{commons.addComma(Number(props.certissueInfo?.stlmAmt))} 원</td>
            </tr>
            <tr>
              <th scope="row">취소일자</th>
              <td>{props.certissueInfo?.rtrcnDt === null ? '-' : moment(props.certissueInfo?.rtrcnDt, 'YYYYMMDD').format('YYYY.MM.DD')}</td>
            </tr>
          </tbody>
        </table>
        */}
        <div className="btn-block">
          {/* 운영 결제 관련 사용안함 2022-07-29
          {props.certissueInfo?.sts === '02' && props.certissueInfo?.rtrcnDt === null ? (
            <a className="btn-secondary md cursor" onClick={() => doSett(props.certissueInfo?.crtSeq)}>
              결제취소
            </a>
          ) : (
            <></>
          )}
 		*/}
          <span className="right">
            <a href="#" className="btn-secondary md" onClick={goList}>
              목록으로
            </a>
          </span>
        </div>
        <div className="guide-box gray mt20">
          <dl className="dlist1">
            <dt>구매확인서 문서 보존기간은 발급일자 기준 1년 입니다.</dt>
          </dl>
        </div>
      </div>
      {/* //contents */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    certissueInfo: state.certissue?.certissueInfo,
  }
}

const actionCreators = {
  getCertissueInfo: certissueActions.getCertissueInfo,
  success: alertActions.success,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(CertIssueDetail)
